// Base
import Image, { StaticImageData } from 'next/image'

// Components
import { Box, Text, Flex } from 'yard-utilities/components'
import Tag from '@components/v25/common/tag/Tag'

// Styles
import styles from './RecentDealCard.module.sass'

// Data
import ImagePlaceholder from '@data/image-placeholder.json'

interface RecentDealCardProps {
  image: string | StaticImageData
  destination: string
  subText?: string
  alignText?: 'left' | 'center' | 'right'
  regularPrice: number
  price: number
  currency?: string
  currencyReversed?: boolean
}

const RecentDealCard = ({
  image,
  destination,
  subText,
  alignText = 'center',
  regularPrice,
  price,
  currency = '$',
  currencyReversed = false
}: RecentDealCardProps) => {
  return (
    <Box className={styles.container}>
      <Image
        src={image}
        alt={`Photo of ${destination}`}
        fill
        sizes="600px"
        priority
        blurDataURL={ImagePlaceholder}
        placeholder="blur"
        className={styles.image}
      />

      <Box
        borderRadius={{ sm: [8, 8, 0, 8] }}
        padding={{ sm: [12] }}
        backgroundColor="yellow-10"
        shadow="shadowDefault"
        className={styles.labelBox}
      >
        <Text
          tagName="h4"
          variant="title-3"
          align={alignText}
          spacing={{ sm: 4 }}
        >
          {destination}
        </Text>

        {subText && (
          <Text
            tagName="h4"
            variant="body-3"
            spacing={{ sm: 4 }}
            textColor="grey-2"
          >
            {subText}
          </Text>
        )}

        <Flex center columnGap={{ sm: 8 }}>
          <Text
            tagName="p"
            variant="body-1"
            align="center"
            fontWeight={500}
            textColor="red"
            decoration="lineThrough"
          >
            {!currencyReversed && currency}
            {regularPrice.toLocaleString()}
            {currencyReversed && currency}
          </Text>

          <Tag
            backgroundColor="yellow"
            textColor="black"
            textSize="body-2"
            variant="type-5"
            fontWeight={700}
          >
            {!currencyReversed && currency}
            {price.toLocaleString()}
            {currencyReversed && currency}
          </Tag>
        </Flex>

        <div className={styles.labelFold} />
      </Box>
    </Box>
  )
}

export default RecentDealCard
